import React from "react";
import { Link } from "react-router-dom";
import { Cpu, Facebook, Instagram, Mail, Phone, Clock } from "lucide-react";
import { businessInfo } from "../mock";
import { areas } from "../data/areas";

const Footer = () => {
  return (
    <footer className="border-t border-emerald-900/40 bg-[#030810]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center">
              <Cpu className="w-5 h-5 text-emerald-400" />
            </div>
            <div>
              <div className="text-white font-bold">{businessInfo.name}</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-emerald-400/80">
                Repair Lab
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm text-emerald-50/60 max-w-md">
            {businessInfo.tagline}. Η ιστοσελίδα αυτή δημιουργήθηκε για τη
            παρουσίαση των υπηρεσιών επισκευής.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a
              href={businessInfo.social.facebook}
              target="_blank"
              rel="noreferrer"
              className="w-9 h-9 rounded-md border border-emerald-700/50 hover:border-emerald-500 text-emerald-300 inline-flex items-center justify-center transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href={businessInfo.social.instagram}
              target="_blank"
              rel="noreferrer"
              className="w-9 h-9 rounded-md border border-emerald-700/50 hover:border-emerald-500 text-emerald-300 inline-flex items-center justify-center transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-emerald-300/80">
            Σύνδεσμοι
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a className="text-emerald-50/75 hover:text-emerald-300" href="/#services">
                Υπηρεσίες
              </a>
            </li>
            <li>
              <a className="text-emerald-50/75 hover:text-emerald-300" href="/#process">
                Διαδικασία
              </a>
            </li>
            <li>
              <a className="text-emerald-50/75 hover:text-emerald-300" href="/#gallery">
                Εργασίες
              </a>
            </li>
            <li>
              <a className="text-emerald-50/75 hover:text-emerald-300" href="/#contact">
                Επικοινωνία
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-emerald-300/80">
            Επικοινωνία
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2 text-emerald-50/75">
              <Phone className="w-4 h-4 mt-0.5 text-emerald-400" />
              {businessInfo.mobile}
            </li>
            <li className="flex items-start gap-2 text-emerald-50/75">
              <Phone className="w-4 h-4 mt-0.5 text-emerald-400" />
              {businessInfo.mobile2}
            </li>
            <li className="flex items-start gap-2 text-emerald-50/75">
              <Mail className="w-4 h-4 mt-0.5 text-emerald-400" />
              {businessInfo.email}
            </li>
            <li className="flex items-start gap-2 text-emerald-50/75">
              <Clock className="w-4 h-4 mt-0.5 text-emerald-400" />
              24/7 — Πάντα ανοιχτά
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-emerald-900/40">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-emerald-100/50" data-testid="footer-area-links">
          <span className="uppercase tracking-[0.2em] text-emerald-300/70">Επισκευή κινητών:</span>
          {areas.map((a) => (
            <Link key={a.slug} to={a.path} className="hover:text-emerald-300 transition-colors">
              {a.name}
            </Link>
          ))}
          <Link to="/blog" className="hover:text-emerald-300 transition-colors">Blog</Link>
        </div>
      </div>
      <div className="border-t border-emerald-900/40">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-emerald-100/40">
          <div>
            © {new Date().getFullYear()} {businessInfo.name}. Όλα τα δικαιώματα
            διατηρούνται.
          </div>
          <div>Designed with care • Repair Lab</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
